import { HubConnectionBuilder } from "@microsoft/signalr";

export const createConnection = (
  token: string,
  requestedBusinessUnitId: string
) => {
  return new HubConnectionBuilder()
    .withUrl(`/entityhub?businessUnit=${requestedBusinessUnitId}`, {
      accessTokenFactory: () => {
        return token;
      }
    })
    .build();
};

const oneHourDelay = 3600000;

export const calculateMsDelay = (
  retryCount: number,
  source = "sagas",
  error: any = null
) => {
  console.error(`SignalR failed to connect (${source})`, error);
  const useDelayCap = retryCount >= 11; // 11th retry takes ~1 hour
  const msDelay = useDelayCap ? oneHourDelay : 4000 * 2 ** (retryCount - 1); // 2, 4, 8, 16, etc
  console.error(`Retrying in ${msDelay} milliseconds`);
  return msDelay;
};
